import { takeLatest, put, call, select } from "redux-saga/effects";
import { IObservationService, TGetObservationPageValue } from "../../services/observationService";
import { requestObservationListPage, createSuccessFetchObservationListPageAction, createFailureFetchObservationListPageAction, createSetObservationPaginationItemsCountAction } from "../actions/observationListActions";
import { createAppendToPersonList } from "../actions/personAction";
import { selectObservationPagination, selectObservationFilters } from "../selectors/observationListSelectors";
import { IPagination } from "../../interfaces/common/IPagination";
import { IObservationFilters } from "../reducers/observationListReducer";

const makeFetchObservationsPageSaga = (observationService: IObservationService) => function* saga() {

    const pagination: IPagination = yield select(selectObservationPagination);
    const filters: IObservationFilters = yield select(selectObservationFilters);

    const result: TGetObservationPageValue = yield call(
        observationService.getObservationPage,
        pagination,
        filters,
    );

    if (result.isFailure === true) {
        yield put(createFailureFetchObservationListPageAction(result.error));
    } else {
        if (result.value.context.persons) {
            yield put(createAppendToPersonList(result.value.context.persons));
        }

        yield put(createSetObservationPaginationItemsCountAction(result.value.totalItems));
        yield put(createSuccessFetchObservationListPageAction(result.value.observations));
    }
};

export default function create(observationService: IObservationService) {
    return takeLatest(requestObservationListPage, makeFetchObservationsPageSaga(observationService));
}
